function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10,
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.881 15.756c.493.427 1.142.735 1.842.937A8.308 8.308 0 0012 17c.786 0 1.57-.103 2.277-.307.7-.202 1.35-.51 1.842-.937",
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 10,
  r: 1,
  fill: "#243143",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 10,
  r: 1.25,
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 0.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 10,
  r: 1,
  fill: "#243143",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 10,
  r: 1.25,
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 0.5,
  strokeLinecap: "round"
});

function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIHN0cm9rZT0iIzI0MzE0MyIgc3Ryb2tlLW9wYWNpdHk9IjAuNiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTcuODgxMjQgMTUuNzU1OUM4LjM3MzkxIDE2LjE4MjYgOS4wMjMwOSAxNi40OTA5IDkuNzIyNjUgMTYuNjkyOEMxMC40MzAxIDE2Ljg5NyAxMS4yMTQyIDE3IDEyIDE3QzEyLjc4NTggMTcgMTMuNTY5OSAxNi44OTcgMTQuMjc3NCAxNi42OTI4QzE0Ljk3NjkgMTYuNDkwOSAxNS42MjYxIDE2LjE4MjYgMTYuMTE4OCAxNS43NTU5IiBzdHJva2U9IiMyNDMxNDMiIHN0cm9rZS1vcGFjaXR5PSIwLjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxjaXJjbGUgY3g9IjkiIGN5PSIxMCIgcj0iMSIgZmlsbD0iIzI0MzE0MyIgZmlsbC1vcGFjaXR5PSIwLjYiLz4KPGNpcmNsZSBjeD0iOSIgY3k9IjEwIiByPSIxLjI1IiBzdHJva2U9IiMyNDMxNDMiIHN0cm9rZS1vcGFjaXR5PSIwLjYiIHN0cm9rZS13aWR0aD0iMC41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxMCIgcj0iMSIgZmlsbD0iIzI0MzE0MyIgZmlsbC1vcGFjaXR5PSIwLjYiLz4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxMCIgcj0iMS4yNSIgc3Ryb2tlPSIjMjQzMTQzIiBzdHJva2Utb3BhY2l0eT0iMC42IiBzdHJva2Utd2lkdGg9IjAuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgHappy as ReactComponent };